import { Component, OnInit } from '@angular/core';

import { environment } from '../../../environments/environment';

import { AuthService } from '../../services/auth.service';
import { DocsService } from '../../services/docs.service';

@Component({
    selector: 'kd-not-found',
    templateUrl: './not-found.component.html',
    styleUrls: ['./not-found.component.scss']
})
export class NotFoundComponent implements OnInit {

    defaultRoute: string;
    isStaff: boolean;
    referrerHelpUrl: string = environment.referrerHelpUrl;

    constructor(
        private authService: AuthService,
        private docsService: DocsService,
    ) { }

    ngOnInit() {
        this.defaultRoute = this.docsService.getDefaultRoute();
        this.isStaff = this.authService.isAuthorized() && this.authService.getAccount().is_staff;
    }

    login(): void {
        this.authService.login();
    }
}
